import {ComponentType} from 'react';
import {NodeProps, EdgeProps} from 'reactflow';

import TaskSchemaControlFlowEdge from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/edges/TaskSchemaControlFlowEdge';
import TaskSchemaDataFlowEdge from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/edges/TaskSchemaDataFlowEdge';
import TaskSchemaNodeRenderer from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TaskSchemaNodeRenderer';

import {
  ProcessFlowchartNodeType,
  ProcessFlowchartEdgeType,
} from './TransitionModalWithFlowchartEditorConstants';

export const TRANSITION_MODAL_WITH_FLOWCHART_EDITOR_NODE_TYPES: Record<
  ProcessFlowchartNodeType,
  ComponentType<NodeProps>
> = {
  [ProcessFlowchartNodeType.TASK_SCHEMA_NODE]: TaskSchemaNodeRenderer,
} as const;

export const TRANSITION_MODAL_WITH_FLOWCHART_EDITOR_EDGE_TYPES: Record<
  ProcessFlowchartEdgeType,
  ComponentType<EdgeProps>
> = {
  [ProcessFlowchartEdgeType.CONTROL_FLOW]: TaskSchemaControlFlowEdge,
  [ProcessFlowchartEdgeType.DATA_FLOW]: TaskSchemaDataFlowEdge,
};
